import jobs from '../data/readingJobs';
export function bibleReadingJob(book, chapter) {
  if (book !== 'ezekiel') return null;
  return jobs.find(job => job.kind === 'bible' && Number(chapter) >= job.chapter && Number(chapter) <= job.endChapter) || null;
}
export function sermonReadingJob(id) {
  return jobs.find(job => job.kind === 'sermon' && job.slug === id) || null;
}
export function addReadingJobLinks(html, book) {
  if (book !== 'ezekiel') return html;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('.reading-job-link').forEach(node => node.remove());
  const append = (node, chapter, verse, placement) => {
    const job = bibleReadingJob(book, chapter);
    if (!job) return;
    const link = doc.createElement('a');
    link.className = 'reading-job-link';
    link.href = job.path;
    link.title = '読んで稼ぐ';
    link.setAttribute('aria-label', `読んで稼ぐ：エゼキエル書 ${chapter}章${verse}節の朗読募集（${job.label}）`);
    link.textContent = '¥';
    if (placement === 'after') node.after(link); else node.appendChild(link);
  };
  const buttons = doc.querySelectorAll('[data-commentary-verse]');
  if (buttons.length) {
    buttons.forEach(button => { const [chapter, verse] = button.dataset.commentaryVerse.split('-'); append(button, chapter, verse, 'after'); });
  } else {
    doc.querySelectorAll('em, td.vn').forEach(marker => {
      const match = marker.textContent.trim().match(/(\d+):(\d+)/);
      if (!match) return;
      const block = marker.closest('.bible-reading-verse, .gal-verse, .hebrew-verse');
      if (marker.matches('td')) { const cell = marker.closest('tr')?.querySelector('td.v'); if (cell) append(cell, match[1], match[2]); }
      else if (block) append(block, match[1], match[2]);
      else if (marker.nextElementSibling?.matches('span[id="verse"]')) append(marker.nextElementSibling, match[1], match[2], 'after');
    });
  }
  return doc.body.innerHTML;
}
